import Star from "../public/img/star.svg";

interface SeparatorProps {
  classes?: string;
  starClasses?: string;
  hideLeft?: boolean;
  color?: string;
}

export default function Separator(props: SeparatorProps) {
  const color = props.color == undefined ? "neutral-300" : props.color;
  return (
    <div className={`w-full grid grid-cols-1 items-center ${props.classes}`}>
      <hr
        className={`row-start-1 col-start-1 my-0 border-${color} ${
          props.hideLeft ? "mr-2" : "mx-2"
        }`}
      ></hr>
      <div
        className={`row-start-1 col-start-1 flex justify-between ${props.starClasses}`}
      >
        {props.hideLeft ? <div /> : <Star />}
        <Star />
      </div>
    </div>
  );
}
